export const envHasDevFlagsEnabled = () =>
  process.env['NEXT_PUBLIC_LAUNCH_DARKLY_DEVELOPMENT_FLAGS_ENABLED'] === 'true';
